import { AXEPTIO_AUTHORIZED_VENDORS } from "@/constants/axeptio.constants";

import { getCookieValue } from "./getCookieValue";

export const getAxeptioVendorCookie = (
  vendorKey: string
): { isVendorActive: boolean } => {
  const axeptioAuthorizedVendors: Array<string> =
    getCookieValue(AXEPTIO_AUTHORIZED_VENDORS)?.split(",") || [];

  const isVendorActive = axeptioAuthorizedVendors.includes(vendorKey);

  return { isVendorActive };
};
